export const WHATSAPP_NUMBER =
  process.env.REACT_APP_WHATSAPP_NUMBER || "918828201255";

export const buildWhatsAppLink = (
  message = "Hi! I'm interested in your services at Nikhil Digital Solutions.",
) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
